import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Classes from "./AppointmentDetails.module.css";
import MoreDropDown from "./MoreDropDown";
import Sidebar from "./Components/Sidebar/Sidebar";
import Details from "./Components/Details/Details";
import Invoices from "./Components/Invoices/Invoices";
import Documents from "./Components/Documents/Documents";
import { LeftArrowIcon } from "../../../../../../utils/Icons";
import backend from "../../../../../../api";
import { useSelector } from "react-redux";

export default function AppointmentDetails() {
  const navigateTo = useNavigate();
  const { tab, id } = useParams();
  const [activeTab, setActiveTab] = useState(tab || "details");
  const [booking, setBooking] = useState(null);
  const { token } = useSelector(s => s?.auth || {});

  const load = useCallback(async () => {
    try {
      const { data } = await backend.get(`/api/bookings/${id}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      setBooking(data?.data || null);
    } catch (e) {
      console.error("load booking error", e);
      setBooking(null);
    }
  }, [id, token]);

  useEffect(() => { setActiveTab(tab || "details"); }, [tab]);
  useEffect(() => { if (id) load(); }, [id, load]);

  const handleTabChange = (next) => {
    setActiveTab(next);
    navigateTo(`/view-appointment/${next}/${id}`);
  };

  return (
    <div className={Classes.container}>
      <div className={Classes.header}>
        <button onClick={() => navigateTo(-1)} className={Classes.backButton}>
          <LeftArrowIcon height="12px" fill="#969696" />
          <h5>Go back</h5>
        </button>
        <MoreDropDown booking={booking} />
      </div>

      <div className={Classes.hero}>
        <div className={Classes.heroLeft}>
          <Sidebar activeTab={activeTab} setActiveTab={handleTabChange} />
        </div>

        <div className={Classes.heroRight}>
          <div className="flexAlign10 mb-20">
            <h3 className={Classes.mainTitle}>{booking && booking?.userId?.firstName + " " + booking?.userId?.lastName || booking?.userId?.email}</h3>
          </div>

          {activeTab === "details" && <Details booking={booking} refresh={load} />}
          {activeTab === "invoices" && <Invoices bookingId={id} />}
          {activeTab === "documents" && <Documents bookingId={id} booking={booking} refresh={load} />}
        </div>
      </div>
    </div>
  );
}
